/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Options_Error_CustomInputs */



/**
* | output |
* | --- |
* | "The choices could not be loaded. You can still enter the value manually." |
*
* @param {Spaces_Modular_Wizard_Options_Error_CustomInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_options_error_custom = /** @type {((inputs?: Spaces_Modular_Wizard_Options_Error_CustomInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Options_Error_CustomInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Auswahl konnte nicht geladen werden. Sie können den Wert trotzdem manuell eingeben.")
	return /** @type {LocalizedString} */ ("The choices could not be loaded. You can still enter the value manually.")
});